export default {
  data: () => ({
    gifs: {
      exceed: [
        'https://media.giphy.com/media/l4pT2ASyWWGw4NbDG/giphy.gif',
        'https://media.giphy.com/media/1gevXIZve3nqM/giphy.gif',
        'https://media.giphy.com/media/oz5lXwIn4LS8e3ocPU/giphy.gif',
        'https://media.giphy.com/media/JlpjgShzDsrMIyFu5U/giphy.gif',
        'https://media.giphy.com/media/lEVZJzy4w15qE/giphy.gif',
        'https://media.giphy.com/media/8RxCFgu88jUbe/giphy.gif',
        'https://media.giphy.com/media/c4rB7DMXKgktG/giphy.gif',
        'https://media.giphy.com/media/a0Lgc1JvbfS4o/giphy.gif',
        'https://media.giphy.com/media/10spcFioEOY7zG/giphy.gif',
        'https://media.giphy.com/media/Hc8PMCBjo9BXa/giphy.gif',
        'https://media.giphy.com/media/Jf4FBs6JZhvKU/giphy.gif',
        'https://media.giphy.com/media/qjfeT5XdAirCg/giphy.gif',
        'https://media.giphy.com/media/msKNSs8rmJ5m/giphy.gif',
      ],
      meet: [
        'https://media.giphy.com/media/26tPghhb310muUkEw/giphy.gif',
        'https://media.giphy.com/media/l2JdXy8xasypvE0Ni/giphy.gif',
        'https://media.giphy.com/media/10hO3rDNqqg2Xe/giphy.gif',
        'https://media.giphy.com/media/KYElw07kzDspaBOwf9/giphy.gif',
        'https://media.giphy.com/media/3rgXBQIDHkFNniTNRu/giphy.gif',
        'https://media.giphy.com/media/blSTtZehjAZ8I/giphy.gif',
        'https://media.giphy.com/media/13Iu9mjLpXF0ek/giphy.gif',
        'https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif',
        'https://media.giphy.com/media/YTbZzCkRQCEJa/giphy.gif',
        'https://media.giphy.com/media/s2qXK8wAvkHTO/giphy.gif',
        'https://media.giphy.com/media/wAxlCmeX1ri1y/giphy.gif',
        'https://media.giphy.com/media/hTh9bSbUPWMWk/giphy.gif',
        'https://media.giphy.com/media/3rgXBvnbXtxwaWmhr2/giphy.gif',
        'https://media.giphy.com/media/3EfgWHj0YIDrW/giphy.gif',
        'https://media.giphy.com/media/yoJC2GnSClbPOkV0eA/giphy.gif',
        'https://media.giphy.com/media/MS3XuWjQV1FiU/giphy.gif',
        'https://media.giphy.com/media/m8crpzTJFRDPhqqhXJ/giphy.gif',
        'https://media.giphy.com/media/l2SqgQWAxWykGxiJW/giphy.gif',
        'https://media.giphy.com/media/kyLYXonQYYfwYDIeZl/giphy.gif',
        'https://media.giphy.com/media/LZElUsjl1Bu6c/giphy.gif',
        'https://media.giphy.com/media/S9iMXx6Lqrr5mJoMxC/giphy.gif',
        'https://media.giphy.com/media/TztOD2c0znrtm/giphy.gif',
        'https://media.giphy.com/media/13hxeOYjoTWtK8/giphy.gif',
        'https://media.giphy.com/media/6fScAIQR0P0xW/giphy.gif',
        'https://media.giphy.com/media/tsX3YMWYzDPjAARfeg/giphy.gif',
        'https://media.giphy.com/media/10AmJ6TIlbYxAk/giphy.gif',
        'https://media.giphy.com/media/pa37AAGzKXoek/giphy.gif',
        'https://media.giphy.com/media/b5LTssxCLpvVe/giphy.gif',
        'https://media.giphy.com/media/2C3hV2vrG901a/giphy.gif',
        'https://media.giphy.com/media/mQczcNXr02qZ2/giphy.gif',
      ],
      needsImprovement: [
        'https://media.giphy.com/media/Zd1BUb0qs6nwjeMUBu/giphy.gif',
        'https://media.giphy.com/media/4WEUNLjAKOICdjjxVt/giphy.gif',
        'https://media.giphy.com/media/tHufwMDTUi20E/giphy.gif',
        'https://media.giphy.com/media/8dYmJ6Buo3lYY/giphy.gif',
        'https://media.giphy.com/media/fhAwk4DnqNgw8/giphy.gif',
        'https://media.giphy.com/media/l0Exe5NhestV2TfC8/giphy.gif',
        'https://media.giphy.com/media/3orifhln1wZJ7lTbyw/giphy.gif',
        'https://media.giphy.com/media/1kenyYNFG9wTUyHMjk/giphy.gif',
        'https://media.giphy.com/media/g2lH60ZcvUGL6/giphy.gif',
        'https://media.giphy.com/media/3LrK7Q7UhF5MnhZ5ja/giphy.gif',
        'https://media.giphy.com/media/1WbJnEhCpZTThmzFTz/giphy.gif',
        'https://media.giphy.com/media/pnirLWImenPAk/giphy.gif',
      ],
    },
  }),
};
